import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { evictAndReload } from './evict-service-worker'
import './index.css'

/* §9.282, FB-440 — before React mounts, and never awaited: a worker left on this origin by the
 * customer build keeps serving its cached bundle here, which is the owner's *"sometimes I see
 * zákaznícku stránku"*. It never throws, so a failure to tidy up cannot stop the manager starting. */
void evictAndReload()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('index.html is missing the #root mount point')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
